import Vue from 'vue'
import Can from "./can";

// Libera o acesso se o usuário possui alguma das permissões
Vue.directive('can-any-role', {
    bind: Can.can_any_role
});

// Libera o acesso se o usuário possui todas as permissões
Vue.directive('can-all-roles', {
    bind: Can.can_all_roles
});

// Libera o acesso se o id do usuário estiver entre os passados
Vue.directive('can-user-id-in', {
    bind: Can.can_user_id_in
});

// Libera o acesso se o usuário estiver autenticado
Vue.directive('can-user-authenticated', {
    bind: Can.can_user_authenticated
});

// Libera o acesso se o usuário não estiver autenticado
Vue.directive('can-user-unauthenticated', {
    bind: Can.can_user_unauthenticated
});
